import styled from 'styled-components';
import Text from './Text';

const EllipsisText = styled(Text)`
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export default EllipsisText;
